<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import CreateReferralForm from "@/components/referral/CreateReferralForm.vue";

export default {
  name: "ReferralsPage",
  components: { Layout, PageHeader, CreateReferralForm },
  data() {
    return {
      title: "Referrals",
      items: [
        { text: "Nazox", href: "/" },
        { text: "Referrals", active: true }
      ],
      // Mock data reused similar to Doctors dashboard
      referralPatients: [
        { id: 1, name: "Swaraj Bhuyan", mrn: 8364, dob: "1990-03-12", gender: "Male" },
        { id: 2, name: "John Doe", mrn: 1234, dob: "1985-07-21", gender: "Male" },
        { id: 3, name: "Jane Smith", mrn: 5678, dob: "1992-11-05", gender: "Female" }
      ],
      referralDepartments: [
        { id: 1, name: "Cardiology" },
        { id: 2, name: "Neurology" },
        { id: 3, name: "Orthopedics" }
      ],
      referralDoctors: [
        { id: 11, name: "Dr. Arvind Rao", departmentId: 1 },
        { id: 12, name: "Dr. Nisha Patel", departmentId: 2 },
        { id: 13, name: "Dr. Vikram Singh", departmentId: 3 }
      ],
      referralHospitals: [
        { id: 101, name: "City Hospital" },
        { id: 102, name: "General Hospital" },
        { id: 103, name: "Sunrise Medical Center" }
      ],
      referrals: [],
      showReferralForm: false
    };
  },
  methods: {
    getUrgencyVariant(u) {
      switch (u) {
        case 'Low': return 'secondary';
        case 'Medium': return 'info';
        case 'High': return 'warning';
        case 'Critical': return 'danger';
        default: return 'secondary';
      }
    },
    getDepartmentName(id) {
      const d = this.referralDepartments.find(x => x.id === id);
      return d ? d.name : '-';
    },
    getDoctorName(id) {
      const d = this.referralDoctors.find(x => x.id === id);
      return d ? d.name : '-';
    },
    formatDateTime(dt) {
      const d = new Date(dt);
      if (isNaN(d.getTime())) return dt;
      return d.toLocaleString();
    },
    onReferralSubmit(ref) {
      const id = Date.now();
      this.referrals.unshift({ ...ref, id });
      this.showReferralForm = false;
    },
    onReferralCancel() {
      this.showReferralForm = false;
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-xl-8">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Referrals</h4>
            <div class="table-responsive">
              <table class="table table-centered table-nowrap mb-0">
                <thead class="thead-light">
                  <tr>
                    <th>Patient</th>
                    <th>Type</th>
                    <th>Department</th>
                    <th>Doctor</th>
                    <th>Urgency</th>
                    <th>Created</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!referrals.length">
                    <td colspan="6" class="text-center text-muted">No referrals yet</td>
                  </tr>
                  <tr v-for="ref in referrals" :key="ref.id">
                    <td>{{ ref.patient ? ref.patient.name : '' }} <small class="text-muted">(Mrn: {{ ref.patient ? ref.patient.mrn : '' }})</small></td>
                    <td>
                      <span :class="`badge bg-${ref.type === 'internal' ? 'primary' : 'secondary'} font-size-12`">{{ ref.type }}</span>
                    </td>
                    <td>{{ getDepartmentName(ref.departmentId) }}</td>
                    <td>{{ getDoctorName(ref.doctorId) }}</td>
                    <td>
                      <span :class="`badge bg-${getUrgencyVariant(ref.urgency)} font-size-12`">{{ ref.urgency }}</span>
                    </td>
                    <td>{{ formatDateTime(ref.createdAt) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center">
              <h4 class="card-title mb-0">New Referral</h4>
              <button class="btn btn-sm btn-primary" @click="showReferralForm = !showReferralForm">{{ showReferralForm ? 'Hide' : 'Create Referral' }}</button>
            </div>
            <div class="mt-3">
              <CreateReferralForm
                :show="showReferralForm"
                :patients="referralPatients"
                :departments="referralDepartments"
                :doctors="referralDoctors"
                :hospitals="referralHospitals"
                @update:show="val => showReferralForm = val"
                @submit="onReferralSubmit"
                @cancel="onReferralCancel"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
</style>
